import React, { useContext, useEffect, useState } from 'react';
import { Components } from '../../styled';
import ProjectTableHeader from '../../../../components/ProjectTableHeader';
import useFormTextState from '../../../../hooks/useFormTextState';
import ProjectTable from '../../../../components/ProjectTable';
import { filteringModel, tableColumns } from '../../../../components/ProjectTable/constants';
import { ActivityIndicatorContext } from '../../../../providers/ActivityIndicatorProvider/context';
import useModalState from '../../../../hooks/useModalState';
import { Category } from '../../../../api/types/contentManagement';
import { getAllCategories } from '../../../../api/contentManagement';
import CreateOrEditCategoryModal from '../../../../components/modals/CreateOrEditCategoryModal';

const Categories = ({
  setShouldRefreshContext,
}: {
  setShouldRefreshContext: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { setIsLoading } = useContext(ActivityIndicatorContext);

  const [data, setData] = useState<Category[]>([]);

  const searchProps = useFormTextState();

  const createCategoryModalProps = useModalState<{ category?: Category }>();

  const refreshData = async () => {
    setIsLoading(true);
    const result = await getAllCategories();
    setIsLoading(false);
    if (result && Array.isArray(result)) {
      setData(result);
    }
  };

  useEffect(() => {
    refreshData().then();
  }, []);

  const onAddCategory = () => {
    createCategoryModalProps.open({ category: undefined });
  };
  const onEditCategory = (id: string) => {
    const foundCategory = data?.find((item) => item?.id === id);
    if (foundCategory) {
      createCategoryModalProps.open({ category: foundCategory });
    }
  };

  const onCreateOrEditModalClose = (refreshTrigger?: boolean) => {
    if (refreshTrigger) {
      refreshData?.().then();
      setShouldRefreshContext(true);
    }
    createCategoryModalProps.onModalClose();
  };

  const _filteringModel = filteringModel([
    { columnField: 'searchValue', value: searchProps.value, operatorValue: 'contains' },
  ]);
  return (
    <Components.ComponentContainer>
      <ProjectTableHeader
        onSearchChange={searchProps.onChangeText}
        searchLabel={'Search by category name or ID'}
        searchPlaceholder={'Enter search term'}>
        <Components.SearchBarSeparator />
        <Components.PrimaryButton onClick={onAddCategory}>Add Category</Components.PrimaryButton>
      </ProjectTableHeader>
      <Components.TableWrapper>
        <ProjectTable
          data={data || []}
          columns={tableColumns.categories({ onEdit: onEditCategory })}
          filteringModel={_filteringModel}
          showRowCountText={'Found categories'}
          customPageSize={15}
          sortingModel={{ field: 'name', sort: 'asc' }}
        />
      </Components.TableWrapper>
      <CreateOrEditCategoryModal {...createCategoryModalProps} onModalClose={onCreateOrEditModalClose} />
    </Components.ComponentContainer>
  );
};

export default Categories;
